<template>
  <div>
    <div class="label">
      <div>利用期限</div>
      <div>Expiration date</div>
    </div>
    <div class="value">
      <span class="year"
        >{{ displayDatetime(limit).split(/[./\s/]/)[0] }}.</span
      >
      <span class="date"
        >{{ displayDatetime(limit).split(/[./\s/]/)[1] }}.{{
          displayDatetime(limit).split(/[./\s/]/)[2]
        }}</span
      >
      <span class="time">{{ displayDatetime(limit).split(/[./\s/]/)[3] }}</span>
      まで
    </div>
  </div>
</template>

<script>
export default {
  name: "PFaceUseEndPeriod",
  props: {
    limit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  line-height: 21px;
}

.value {
  display: flex;
  height: 50px;
  align-items: flex-end;
  font-size: 11px;
  font-weight: normal;
}

.year {
  font-size: 5vw;
  font-weight: bold;
}

.date {
  margin-bottom: -5px;
  margin-right: 5px;
  font-size: 12vw;
  font-weight: bold;
}

.time {
  margin-bottom: -3px;
  margin-right: 5px;
  font-size: 5vw;
  font-weight: bold;
}
</style>
